import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import PropTypes from "prop-types";
import ActiveJobs from "../components/activeJobs";
import { useSearchParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import Createjobdrawer from "../components/createjobdrawer";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        flex: 1,
        minHeight: 0,
        display: value === index ? "flex" : "none",
        flexDirection: "column",
        overflow: "hidden",
      }}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const JobOrders = () => {
  const PermissionStatus = useSelector((state) => state.user.permissions);
  const AddJobPermissionStatus = PermissionStatus?.["400"];

  const [value, setValue] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [createJobOpen, setCreateJobOpen] = useState(false);

  // ── FIX: isSuccess ki jagah refreshKey counter ──
  // Pehle: isSuccess true → false = 2 state changes = 2 re-renders = 2 API hits
  // Ab: refreshKey sirf ek baar increment = 1 re-render = 1 API hit
  const [refreshKey, setRefreshKey] = useState(0);

  const [inputValue, setInputValue] = useState(
    searchParams.get("search") || "",
  );
  const [searchQuery, setSearchQuery] = useState(
    searchParams.get("search") || "",
  );
  const handleTabChange = (newValue) => {
    setValue(newValue);
    setInputValue("");
    setSearchQuery("");
    setSearchParams({ page: 1 });
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setInputValue(query);
    setSearchQuery(query);
    setSearchParams(query ? { page: 1, search: query } : { page: 1 });
  };

  const handleClearSearch = () => {
    setInputValue("");
    setSearchQuery("");
    setSearchParams({ page: 1 });
  };

  const handleCreateJobSuccess = () => {
    setRefreshKey((prev) => prev + 1);
  };

  useEffect(() => {
    localStorage.setItem("jobOrdersTab", value.toString());
  }, [value]);

  const tabs = ["Active Jobs", "Inactive Jobs"];

  return (
    <Box
      sx={{
        borderRadius: "12px 0 0 0",
        padding: "16px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFF",
        boxSizing: "border-box",
      }}
    >
      {/* ── TOP BAR ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
          gap: 2,
          flexShrink: 0,
        }}
      >
        {/* LEFT: Title + Pill Tabs */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Typography
            sx={{ fontSize: "18px", fontWeight: 600, color: "#151D48", px: 1 }}
          >
            Jobs
          </Typography>

          {/* ── Toggle buttons ── */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              height: "34px",
              backgroundColor: "#fff",
              p: "2px",
              gap: "2px",
            }}
          >
            {tabs.map((tab, index) => (
              <Box
                key={index}
                onClick={() => handleTabChange(index)}
                sx={{
                  px: 2,
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: value === index ? "#fff" : "#64748B",
                  backgroundColor: value === index ? "#3F95EA" : "transparent",
                  borderRadius: "8px",
                  transition: "all 0.2s ease",
                  userSelect: "none",
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    backgroundColor: value === index ? "#3585d4" : "#f1f5f9",
                  },
                }}
              >
                {tab}
              </Box>
            ))}
          </Box>
        </Box>

        {/* RIGHT: Search + Post a Job */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <TextField
            variant="outlined"
            placeholder="Search Job Title"
            size="small"
            value={inputValue}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: "18px", color: "#94a3b8" }} />
                </InputAdornment>
              ),
              endAdornment: inputValue ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={handleClearSearch}
                    sx={{ p: "2px" }}
                  >
                    <CloseIcon sx={{ fontSize: "16px", color: "#94a3b8" }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            sx={{
              width: "220px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                backgroundColor: "#fff",
                fontSize: "14px",
                height: "32px",
              },
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") e.preventDefault();
            }}
          />

          {AddJobPermissionStatus?.add === 1 && (
            <Button
              startIcon={<AddIcon />}
              onClick={() => setCreateJobOpen(true)}
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "#3F95EA",
                borderRadius: "8px",
                textTransform: "uppercase",
                fontWeight: 500,
                fontSize: "14px",
                px: 2.5,
                height: "32px",
                whiteSpace: "nowrap",
                "&:hover": { backgroundColor: "#005a9e" },
              }}
            >
              Post a Job
            </Button>
          )}
        </Box>
      </Box>

      {/* White card wrapper */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          backgroundColor: "#fff",
          borderRadius: "12px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CustomTabPanel value={value} index={0}>
          <ActiveJobs
            isActive={1}
            refreshKey={refreshKey}
            searchQuery={searchQuery}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ActiveJobs
            isActive={0}
            refreshKey={refreshKey}
            searchQuery={searchQuery}
          />
        </CustomTabPanel>
      </Box>

      {createJobOpen && (
        <Createjobdrawer
          open={createJobOpen}
          onClose={() => setCreateJobOpen(false)}
          setIsSuccess={handleCreateJobSuccess}
          disableNavigation
        />
      )}
    </Box>
  );
};

export default JobOrders;
